import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  container: {
    width: '100%',
    maxWidth: 1032,
    margin: '24px auto 210px auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 'unset',
      maxWidth: 'unset',
      margin:'24px -16px 72px -16px',
    },
  },
  buttonWrapper: {
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '0 16px',
      '& button': {
        width: '100%',
      },
    },
  },
}), { name: 'ChooseInvestmentAmount' });
